// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const sidebarSections: PaneSection[] = [
  {
    section: 'settings-sidebar-intro',
    title: 'Sidebar and panels',
    body: 'This is where you arrange your layout. Pick which side each panel sits on, and the chat itself always stays in the middle.',
  },
  {
    section: 'settings-sidebar-conversations',
    title: 'Conversations',
    body: 'Choose which side your chat list docks to. It sits on the left by default.',
  },
  {
    section: 'settings-sidebar-threads',
    title: 'Threads',
    body: 'Choose which side the threads panel docks to, so replies show up where you want them.',
  },
  {
    section: 'settings-sidebar-notes',
    title: 'Notes',
    body: 'Choose which side the notes panel docks to, so your notes stay within easy reach.',
  },
  {
    section: 'settings-sidebar-tasks',
    title: 'Tasks',
    body: 'Choose which side the tasks panel docks to, so you can keep your to-dos where you like them.',
  },
];
